import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";
import {handleAndDownloadExcel} from "@/utils/dowloadExcel";
import groupExcelService from "@/services/Finance_Kids_V2/GroupExcelService";
import GroupExcelService from "@/services/Finance_Kids_V2/GroupExcelService";

export default {
    data() {
        return {
            loadingBill: false,
            isOrderOpen: false,
            isOrderDestroy: false,
        }
    },
    methods: {
        // In hóa đơn hàng loạt theo tháng theo nhóm
        exportBillAllByMonth(date, idGroup, guiId) {
            const params = {
                guiId: guiId,
                date: date,
                idGroup: idGroup
            }
            groupExcelService.exportExcelForAllKidsInMonth(params).then((response) => {
                if (response.data.message === "processing") {
                    this.$notify.info({
                        title: "Thông báo",
                        message: "Dữ liệu đang được xử lý !",
                    });
                }
                const checkProcess = setInterval(() => {
                    groupExcelService
                        .exportExcelForAllKidsInMonth(params)
                        .then((res) => {
                            // chạy neeus k conf processing
                            if (res.data.message === "processing") {
                                this.loadingBill = true
                                return;
                            }
                            if (res.data.message === "fail") {
                                this.loadingBill = false
                                clearInterval(checkProcess)
                                this.$notify.error({
                                    title: "Thông báo",
                                    message: "Lỗi không xuất được dữ liệu !",
                                });
                                return;
                            } else {
                                this.loadingBill = false
                                this.$notify.success({
                                    title: "Thông báo",
                                    message: "Dữ liệu xuất thành công",
                                });

                                const excelFilename = res.data.message.split('complete_')[1]; // Provide a desired filename for the downloaded file
                                clearInterval(checkProcess);
                                return financeKidsV2Service
                                    .downloadBillToExcel(guiId)
                                    .then((res) => {
                                        const excelData = res.data;
                                    // Provide a desired filename for the downloaded file
                                        handleAndDownloadExcel(excelData, excelFilename);
                                    });

                            }
                        })
                        .catch((err) => {
                            return Promise.reject(err);
                        });
                }, 5000);
            })
        },

        // khôi phục phiếu thu
        openOrder(idKidList, dataSearch, showListForApp) {
            if (idKidList.split(",").map(Number).indexOf(0) === 0) {
                this.$message({
                    message: "Chưa có học sinh nào được chọn",
                    type: "error",
                });
            } else {
                this.$confirm("Bạn có muốn khôi phục hóa đơn?", "Thông báo !", {
                    distinguishCancelAndClose: true,
                    closeOnClickModal: false,
                    confirmButtonText: "Có",
                    cancelButtonText: "Không",
                }).then(() => {
                    showListForApp.date = this.$funcCommon.formatMY(dataSearch.createdYear, dataSearch.month);
                    showListForApp.idKidList = idKidList.split(",").map(Number);
                    showListForApp.collectionTurn = dataSearch.collectionTurn;
                    showListForApp.idGroup=dataSearch.idGroup

                    groupExcelService
                        .openOrderKidsExcelForGroup(showListForApp)
                        .then(() => {
                            this.$message({
                                message: "Khôi phục phiếu thu thành công",
                                type: "success",
                            });
                            this.isOrderOpen = !this.isOrderOpen
                        })
                        .catch((err) => {
                            this.$message({
                                message: err.response.data.message,
                                type: "error",
                            });
                        });
                });
            }
        },

        // xóa phiếu thu hoàn toàn
        destroyOrder(idKidList, dataSearch, showListForApp) {
            if (idKidList.split(",").map(Number).indexOf(0) === 0) {
                this.$message({
                    message: "Chưa có học sinh nào được chọn",
                    type: "error",
                });
            } else {
                this.$confirm("Bạn có chắc chắn muốn xóa hóa đơn?", "Thông báo !", {
                    distinguishCancelAndClose: true,
                    closeOnClickModal: false,
                    confirmButtonText: "Có",
                    cancelButtonText: "Không",
                }).then(() => {
                    showListForApp.date = this.$funcCommon.formatMY(dataSearch.createdYear, dataSearch.month);
                    showListForApp.idKidList = idKidList.split(",").map(Number);
                    showListForApp.collectionTurn = dataSearch.collectionTurn;
                    showListForApp.idGroup=dataSearch.idGroup
                    groupExcelService
                        .destroyOrderKidsExcelForGroup(showListForApp)
                        .then(() => {
                            this.$message({
                                message: "Xóa phiếu thu thành công",
                                type: "success",
                            });
                            GroupExcelService
                                .getCollectionTurn(
                                    dataSearch.month,
                                    dataSearch.idGroup,
                                    dataSearch.createdYear
                                )
                                .then((res) => {
                                    if (res.data === 0) {
                                        this.dataSearch.collectionTurn = null;
                                        this.collectionTurn = null;
                                        this.$store.commit("groupExcelModule/loading_data")
                                        this.$store.dispatch("groupExcelModule/init_kids_data", this.dataSearch);
                                        return;
                                    }
                                    this.collectionTurn = res.data;
                                    this.dataSearch.collectionTurn = this.collectionTurn;
                                    this.$store.commit("groupExcelModule/loading_data")
                                    this.$store.dispatch("groupExcelModule/init_kids_data", this.dataSearch);
                                });
                            this.isOrderDestroy = !this.isOrderDestroy
                        })
                        .catch((err) => {
                            this.$message({
                                message: err.response.data.message,
                                type: "error",
                            });
                        });
                });
            }
        },

    }
}